import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateHelper } from 'xproj-lib';

@Pipe({
  name: 'bmsdateformatpipe'
})
export class BmsDateFormat implements PipeTransform {

  private dateHelper: DateHelper = inject(DateHelper);

  transform(date: Date, format : string, displayUTC: boolean = false): string {
    let d = displayUTC ? this.dateHelper.utils.addMinutes(date, date.getTimezoneOffset()) : date;
    return this.dateHelper.utils.formatByString(d, format);
  }

}
